<template>
  <section>
    <Feature v-if="isMutiple" :title="$t('GROUP_KEY')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('TOTAL') + ': ' + quotationList.length]" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Select class="Select" slot="a" v-model="formNo" @on-change="changeFormNo" style="width: 200px">
          <Option v-for="(item, index) in quotationList" :value="item.formNo" :key="index">{{ item.formNo }}</Option>
        </Select>
      </FormRowTwo>
    </Feature>
    <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('FORM_NO') + ': ', $t('RFQ_TYPE') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT_CODE') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.formNo" slot="a" disabled />
        <Input class="Input" v-model="rfqType" slot="b" disabled />
        <Input class="Input" v-model="quotation.vendorCode" slot="c" disabled />
        <Input class="Input" v-model="quotation.plant" slot="d" disabled />
        <Input class="Input" v-model="quotation.vendorPart" slot="e" disabled />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CURRENCY') + ': ', $t('DELTA_PN') + ': ', $t('DESCRIPTION') + ': ', $t('REMARK') + ': ']"
        :fieldWidthArr="[364, 364, 728, 728]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.currency" slot="a" disabled />
        <Input class="Input" v-model="quotation.deltaPart" slot="b" disabled />
        <Input style="width: 612px" v-model="quotation.deltaPartDesc" type="textarea" slot="c" disabled :rows="1" />
        <Input style="width: 612px" v-model="quotation.ymgrRemark" type="textarea" slot="d" disabled :rows="1" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CATEGORY') + ': ']" :fieldWidthArr="[362]" :fieldSpanWidthArr="[100]">
        <Input class="Input" value="Metal Case" slot="a" disabled />
      </FormRowTwo>
      <FormRowTwo v-if="quotationDocumentView" :fieldNameArr="[$t('PART_SPECIFICATION') + ': ']">
      </FormRowTwo>
      <PLMDocument v-if="quotationDocumentView" :plmQuotationDocuments="plmQuotationDocuments"
        :quotationUuid="quotation.uuid"></PLMDocument>
    </Feature>

    <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('DELTA_BUYER_NAME') + ': ', $t('TARGET_PRICE') + ': ', $t('EMAIL') + ': ']"
        :fieldWidthArr="[364, 364, 728]" :fieldSpanWidthArr="[102, 102, 102]">
        <Input class="Input" v-model="cpcAccountName" slot="a" disabled />
        <Input class="Input" v-model="quotation.targetPrice" slot="b" disabled />
        <Input class="Input" style="width: 612px" v-model="quotation.cpcAccountConstactEmail" type="textarea" slot="c"
          disabled :rows="1" />
      </FormRowTwo>

      <FormRowTwo v-show="hasComments" :fieldNameArr="[$t('COMMENTS') + ': ']" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Button class="Input" icon="ios-create" slot="a" @click="openComments">{{ $t('COMMENTS') }}</Button>
      </FormRowTwo>

      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('REFERENCE_FILE')]">
      </FormRowTwo>
      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('')]">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <Card :title="$t('METAL_CASE_ATTRIBUTES')" class="card-info">
        <FormRowTwo
          :fieldNameArr="[$t('LENGTH') + '(mm)' + ': ', $t('WIDTH') + '(mm)' + ': ', $t('HEIGHT') + '(mm)' + ': ', '*' + $t('GROSS_WEIGHT') + '(kg)' + ': ']"
          :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
          <Input class="Input" v-model="metalQuotation.length" slot="a" :disabled="!quotation.editable" />
          <Input class="Input" v-model="metalQuotation.width" slot="b" :disabled="!quotation.editable" />
          <Input class="Input" v-model="metalQuotation.height" slot="c" :disabled="!quotation.editable" />
          <Input class="Input" v-model="metalQuotation.weight" slot="d" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
        </FormRowTwo>
        <FormRowTwo :fieldNameArr="['*' + $t('RAW_MATERIAL_PRICE') + ': ', '*' + $t('RM_PRICE_DATE') + ': ']"
          :fieldWidthArr="[364, 364]" :fieldSpanWidthArr="[102, 102]">
          <Input class="Input" v-model="metalQuotation.rmPrice" slot="a" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
          <DatePicker class="Input" v-model="metalQuotation.rmPriceDate" type="date" format="yyyy-MM-dd"
            :placeholder="$t('RM_PRICE_DATE')" slot="b" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;"></DatePicker>
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="['*' + $t('RAW_MATERIAL_TYPE') + ': ', '*' + $t('RM_VENDOR') + ': ', '*' + $t('COIL_CENTER') + ': ']"
          :fieldWidthArr="[364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102]">
          <Select class="Select" v-if="quotation.editable" filterable
            style="border-color:red;border-width:1px;border-style:solid;" v-model="rawMaterialDesc"
            @on-change="changeRawMaterialType($event)" :placeholder="$t('CHOOSE')" slot="a">
            <Option v-for="(item) in rawMaterials" :value="item.partNoDesc" :key="item.partNoDesc">
              {{ item.partNoDesc }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="metalQuotation.rawMaterialType.partNoDesc" slot="a"
            :disabled="true" />
          <Select class="Select" v-if="quotation.editable" filterable
            style="border-color:red;border-width:1px;border-style:solid;" v-model="rmVendorName"
            @on-change="changeRmVendor($event)" :placeholder="$t('CHOOSE')" slot="b">
            <Option v-for="(item) in rmVendors" :value="item.vendorName" :key="item.vendorName">
              {{ item.vendorName }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="metalQuotation.rmVendor.vendorCode" slot="b"
            :disabled="true" />
          <Select class="Select" v-if="quotation.editable" filterable
            style="border-color:red;border-width:1px;border-style:solid;" v-model="coilCenterName"
            @on-change="changeCoilCenter($event)" :placeholder="$t('CHOOSE')" slot="c">
            <Option v-for="(item) in coilCenters" :value="item.vendorName" :key="item.vendorName">
              {{ item.vendorName }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="metalQuotation.coilCenter.vendorCode" slot="c"
            :disabled="true" />
        </FormRowTwo>
        <FormRowTwo v-if="showStepTwo" :fieldNameArr="[$t('')]">
          <Table width="600" border :columns="priceColumnList" :data="priceList" slot="a">
          </Table>
        </FormRowTwo>

        <FormRowTwo :fieldNameArr="['*' + $t('YOUR_PRICE'), '/1 ' + quotation.unit]" :fieldWidthArr="[362]"
          :fieldSpanWidthArr="[100]">
          <Input class="Input" v-model="price" slot="a" :disabled="true" ref="yourPrice"
            style="border-color:red;border-width:1px;border-style:solid;" />
        </FormRowTwo>
      </Card>
      <FormRowTwo v-if="quotation.editable"
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]"
        :fieldWidthArr="[554, 554]" :fieldSpanWidthArr="[292, 292]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button class="Input" icon="ios-cloud-upload" style="border-color:red;border-width:1px;border-style:solid;">{{
            $t('UPLOAD') }}</Button>
        </Upload>
        <Button class="Input" type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD')
        }}</Button>
      </FormRowTwo>
      <FormRowTwo v-if="supplierAttachmentExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
            <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
              @click="deleteDocument(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('SUPPLIER_REMARK') + ': ']">
        <Input style="width: 800px" :maxlength="500" type="textarea" :rows="3" v-model="metalQuotation.supplierRemark"
          slot="a"></Input>
      </FormRowTwo>
    </Feature>

    <ButtonRow>
      <Button v-if="quotation.editable" type="primary" @click="Save" slot="0">{{ $t('SAVE') }}</Button>
      <Button v-if="quotation.editable" type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button v-if="isMutiple && quotation.editable" type="primary" @click="Upload" slot="2">{{ $t('UPLOAD') }}</Button>
      <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
      :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="errorMsgModal"
      :title="$t('QUOTATION')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="errorMsgColumnList" :data="errorMessages" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="900" sticky :draggable="true" v-model="uploadModel"
      :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow
        :fieldNameArr="['(STEP2) Quotation File sUpload (File Size < 5MB)', batchAttachmentFile == null ? '' : batchAttachmentFile.name]">
        <Upload slot="a" :before-upload="handleBatchAttachmentUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchAttachmentFile !== null" slot="b" @click="uploadBatchAttachement">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="batchAttachmentUuid" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="batchAttachmentFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <FormRow :fieldNameArr="['Batch Excel File Upload', batchFile == null ? '' : batchFile.name]">
        <Upload slot="a" :before-upload="handleBatchUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchFile !== null" slot="b" @click="uploadBatch">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { FileSchemaList } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import { DownloadFile, FloraEditorConfig, Translate, CheckFloat } from "@/util/common"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "SupplierMetalMatintain",
  props: {
  },
  components: {
    PLMDocument,
    FormRowTwo
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(),
      priceList: [],
      priceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.key) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let styleInfo = {
              'border-width': '1px',
              'border-style': 'solid'
            }
            if (this.priceList[params.index].key == "RM_COST" || this.priceList[params.index].key == "PROCESSING_COST" ||
              this.priceList[params.index].key == "TREATMENT" || this.priceList[params.index].key == "ACCESSORIES") {
              styleInfo['border-color'] = 'red'
            }

            if (this.priceList[params.index].key == "TOTAL_COST" || this.priceList[params.index].key == "RM_RATIO_NO_ACCESSORY") {
              return h("div", {
                domProps: {
                  innerHTML: "<lable>" + this.priceList[params.index].value + "</lable>"
                }
              });
            } else {
              return h('Input', {
                props: {
                  type: 'text',
                  value: this.priceList[params.index].value,
                },
                style: styleInfo,
                on: {
                  'on-change': (event) => {
                    if (event.target.value == '' || CheckFloat(event.target.value)) {
                      this.priceList[params.index].value = event.target.value == '' ? 0 : Number(event.target.value)
                      let sum = Number(0)
                      this.priceList.forEach(price => {
                        if (price.value && (price.key == "RM_COST" || price.key == "PROCESSING_COST" || price.key == "TREATMENT"
                          || price.key == "ACCESSORIES" || price.key == "OTHERS_PROCESS")) {
                          // sum = math.add(sum, price.value)
                          sum = sum + price.value
                        }
                      })
                      this.price = sum.toFixed(3);
                      let rmCost = Number(0)
                      let accessories = Number(0)
                      this.priceList.forEach(price => {
                        if (price.key == "TOTAL_COST") {
                          price.value = sum.toFixed(3);
                        } else if (price.key == "RM_COST") {
                          rmCost = price.value
                        } else if (price.key == "ACCESSORIES") {
                          accessories = price.value
                        } else if (price.key == "RM_RATIO_NO_ACCESSORY") {
                          price.value = Math.floor((rmCost / (sum.toFixed(3) - accessories) * 100) * 10) / 10
                        }
                      })
                    } else {
                      AlertInfo(this, this.$t('PRICE_MUST_BE_NUMBER')).then(() => {
                      })
                    }
                  }
                }
              })
            }
          },
          align: 'center',
          width: 200,
        }
      ],
      comments: '',
      rawMaterialDesc: '',
      rawMaterials: [],
      rmVendorName: '',
      rmVendors: [],
      coilCenterName: '',
      coilCenters: [],
      uuid: '',
      formNo: '',
      quotation: {},
      price: '',
      file: null,
      batchAttachmentFile: null,
      batchFile: null,
      supplierQuotationFiles: [],
      showSupplierQuotationFiles: [],
      plmQuotationDocuments: [],
      cpcToVendorAttachments: [],
      commentsModal: false,
      uploadModel: false,
      errorMsgModal: false,
      errorMessages: [],
      batchAttachmentUuid: "",
      batchAttachmentFiles: [],
      metalQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        rawMaterialType: {
          partNo: '',
          partNoDesc: ''
        },
        rmVendor: {
          vendorCode: ''
        },
        coilCenter: {
          vendorCode: ''
        },
        rmPrice: '',
        rmPriceDate: '',
        rmCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      documentColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FILE_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'fileName',
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLM_FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-download",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.downloadDocument(params.row)
                },
              },
            })
          }
        },
      ],
      scalePriceList: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE'); + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scaleQuantity
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scaleQuantity = event.target.value
                }
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scalePrice
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scalePrice = event.target.value
                }
              }
            })
          }
        }
      ],
      fileSchemaList: FileSchemaList(this),
      errorMsgColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Form No",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('YOUR_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Your Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Unit",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ERROR_MESSAGE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "errorMessage",
          render: (h, params) => {
            let html = "<lable>" + params.row.errorMessage + "</lable>";
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          width: 400,
          align: "center",
        },
      ],
    }
  },
  created() {
    const vueInstance = this
    vueInstance.$getReferenceData(vueInstance, "/steel-reference-price/find/partNo").then(data => {
      vueInstance.rawMaterials = data
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })

    vueInstance.toggleLoading(true)
    if (vueInstance.getSupplierQuotationId()) {
      vueInstance.uuid = vueInstance.getSupplierQuotationId()
      vueInstance.formNo = vueInstance.getSupplierFormNo()
      vueInstance.$searchSupplierMetal(vueInstance, false).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else if (vueInstance.getQuotationList().length > 0) {
      vueInstance.formNo = vueInstance.getQuotationList()[0].formNo
      vueInstance.uuid = vueInstance.getQuotationList()[0].uuid
      vueInstance.$searchSupplierMetal(vueInstance, false).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else {
      vueInstance.toggleLoading(false)
      vueInstance.Back()
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getQuotationList", "getSupplierQuotationId", "getModalSize", "getSupplierFormNo"]),
    ...mapActions(["toggleLoading"]),
    changeRawMaterialType(value) {
      const vueInstance = this
      vueInstance.metalQuotation.rawMaterialType = vueInstance.rawMaterials.find(function (rawMaterial) {
        return rawMaterial.partNoDesc == value
      });
      vueInstance.toggleLoading(true)
      vueInstance.$getReferenceData(vueInstance, "/steel-reference-price/find/vendor/" + vueInstance.metalQuotation.rawMaterialType.uuid).then(data => {
        vueInstance.toggleLoading(false)
        vueInstance.rmVendors = data
        vueInstance.metalQuotation.rmVendor = vueInstance.rawMaterials[0]
        vueInstance.rmVendorName = vueInstance.rawMaterials[0].vendorName
      })
    },
    changeRmVendor(value) {
      const vueInstance = this
      vueInstance.metalQuotation.rmVendor = vueInstance.rmVendors.find(function (vendor) {
        return vendor.vendorName == value
      });

      vueInstance.$getDistributorByVendor(vueInstance, "STEEL", vueInstance.metalQuotation.rmVendor.vendorCode).then(data => {
        vueInstance.coilCenters = data
        if (vueInstance.coilCenters && vueInstance.coilCenters.length > 0) {
          vueInstance.metalQuotation.coilCenter = vueInstance.coilCenters[0]
          vueInstance.coilCenterName = vueInstance.coilCenter[0].vendorName
        } else {
          vueInstance.metalQuotation.coilCenter = {
            vendorCode: ''
          }
          vueInstance.coilCenterName = ''
        }
      })
    },
    changeCoilCenter(value) {
      const vueInstance = this
      vueInstance.metalQuotation.coilCenter = vueInstance.coilCenters.find(function (vendor) {
        return vendor.vendorName == value
      });
    },
    Upload() {
      this.uploadModel = true
    },
    downloadSample() {
      let formNos = []
      this.quotationList.forEach(q => {
        formNos.push(q.formNo)
      })
      this.$downloadExcel(this, "supplier/metal/batch", JSON.stringify(formNos), "")
    },
    handleBatchAttachmentUpload(file) {
      this.batchAttachmentFile = file;
      return false;
    },
    uploadBatchAttachement() {
      let fd = new FormData()
      fd.append('file', this.batchAttachmentFile)
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation", fd)
        .then((response) => {
          this.batchAttachmentFiles = []
          this.batchAttachmentFiles.push(response.data)
          this.batchAttachmentUuid = response.data.uuid
          this.batchAttachmentFile = null
          this.toggleLoading(false)
        })
        .catch(() => {
          this.toggleLoading(false)
        })
    },
    handleBatchUpload(file) {
      this.batchFile = file;
      return false;
    },
    uploadBatch() {
      const vueInstance = this
      let fd = new FormData()
      fd.append('file', this.batchFile)
      let formNos = []
      vueInstance.quotationList.forEach(q => {
        formNos.push(q.formNo)
      })
      fd.append('formNoList', formNos)
      fd.append('fileUuid', vueInstance.batchAttachmentUuid)
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/supplier/metal/batch-upload", fd)
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.batchFile = null
          vueInstance.uploadModel = false
          vueInstance.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
          vueInstance.Back()
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          vueInstance.batchFile = null
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
        })
    },
    changeFormNo(formNo) {
      const vueInstance = this
      let temp = this.getQuotationList().find(quotation => quotation.formNo == formNo)
      vueInstance.formNo = temp.formNo
      vueInstance.uuid = temp.uuid
      vueInstance.toggleLoading(true)
      vueInstance.$searchSupplierMetal(vueInstance, false).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    },
    openComments() {
      this.commentsModal = true
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    deleteDocument(row) {
      this.supplierQuotationFiles.forEach(attachment => {
        if (attachment.id == row.id) {
          attachment.deleted = true
        }
      })
      this.showSupplierQuotationFiles = this.supplierQuotationFiles.filter(attachment => !attachment.deleted)
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      if (this.showSupplierQuotationFiles.length < 1) {
        let fd = new FormData()
        fd.append('file', this.file)
        fd.append('description', "quotaion attachement")
        this.toggleLoading(true)
        this.$fileHttp
          .post("/attachment/upload-single?description=quotation" + this.quotation.uuid, fd)
          .then((response) => {
            this.supplierQuotationFiles.push(response.data)
            this.showSupplierQuotationFiles.push(response.data)
            this.file = null
            this.toggleLoading(false)
          })
          .catch(() => {
            this.toggleLoading(false)
          })
      } else {
        let text = "Could not upload more than one quotation file."
        this.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    },
    Save() {
      const vueInstance = this
      let data = buildCriteria(vueInstance)
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.price, vueInstance.quotation.currency, vueInstance.metalQuotation)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/update", JSON.stringify(data))
          .then((response) => {
            vueInstance.toggleLoading(false)
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Submit() {
      const vueInstance = this
      let data = buildCriteria(vueInstance)
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.price, vueInstance.quotation.currency, vueInstance.metalQuotation)
        + vueInstance.$validSupplierAttachments(vueInstance, vueInstance.showSupplierQuotationFiles.length)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/submit", JSON.stringify(data))
          .then((response) => {
            if (vueInstance.getSupplierQuotationId()) {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            } else if (vueInstance.getQuotationList().length > 0) {
              vueInstance.$searchSupplierMetal(vueInstance, false).then(vueInstance => {
                vueInstance.toggleLoading(false)
              })
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            }
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Back() {
      this.$router.push({ name: 'SUPPLIER_MAINTAIN' })
    },
    valid(formNo, price, currency, metalQuotation) {
      let errorMessage = this.$validSupplierQuotationPrice(this, "FormNo(" + formNo + ") -", price, currency)

      errorMessage = validTemplate(this, errorMessage, metalQuotation.length, false, formNo, this.$t('LENGTH'), 1, this.$t('IS_MORE_THAN_ONE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.width, false, formNo, this.$t('WIDTH'), 1, this.$t('IS_MORE_THAN_ONE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.height, false, formNo, this.$t('HEIGHT'), 1, this.$t('IS_MORE_THAN_ONE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.weight, true, formNo, this.$t('GROSS_WEIGHT'), 5, this.$t('IS_MORE_THAN_FIVE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.rmPrice, true, formNo, this.$t('RAW_MATERIAL_PRICE'), 5, this.$t('IS_MORE_THAN_FIVE_DIGITS'), false);

      if (!metalQuotation.rmPriceDate) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RM_PRICE_DATE') + " <br>"
      }
      if (!metalQuotation.rawMaterialType.partNo) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RAW_MATERIAL_TYPE') + " <br>"
      }
      if (!metalQuotation.rmVendor.vendorCode) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RM_VENDOR') + " <br>"
      }
      if (!metalQuotation.coilCenter.vendorCode) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('COIL_CENTER') + " <br>"
      }

      errorMessage = validTemplate(this, errorMessage, metalQuotation.rmCost, true, formNo, this.$t('RM_COST'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.processingCost, true, formNo, this.$t('PROCESSING_COST'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.treatmentCost, true, formNo, this.$t('TREATMENT'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, metalQuotation.accessoriesCost, true, formNo, this.$t('ACCESSORIES'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), true);
      return errorMessage
    }
  },
  computed: {
    quotationList() {
      return this.getQuotationList()
    },
    isMutiple() {
      return this.getQuotationList() && this.getQuotationList().length > 0
    },
    supplierAttachmentExited() {
      return this.showSupplierQuotationFiles && this.showSupplierQuotationFiles.length > 0
    },
    quotationDocumentView() {
      return this.plmQuotationDocuments && this.plmQuotationDocuments.length > 0
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments && this.cpcToVendorAttachments.length > 0
    },
    rfqType() {
      if (this.quotation.rfqType) {
        return this.quotation.rfqType.description
      } else {
        ""
      }
    },
    cpcAccountName() {
      return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
    },
    modalSize() {
      return this.getModalSize()
    },
    showStepTwo() {
      return this.metalQuotation.weight && this.metalQuotation.rmPrice && this.metalQuotation.rmPriceDate
        && this.rawMaterialDesc && this.rmVendorName && this.coilCenterName
    },
    hasComments() {
      return this.comments != ""
    },
  }
}

function validTemplate(vueInstance, errorMessage, key, isRequire, formNo, keyName, digitsNumber, digitsName, canZero) {
  if (key === undefined || key === "") {
    if (isRequire === true) {
      errorMessage = errorMessage + "FormNo(" + formNo + ") -" + vueInstance.$t('PLEASE_KEY_IN') + keyName + " <br>";
    }
    return errorMessage;
  }
  if (CheckFloat(key) === false) {
    return errorMessage + "FormNo(" + formNo + ") -" + keyName + vueInstance.$t('MUST_BE_NUMBER') + " <br>";
  }
  if (Number(key) < 0 || (Number(key) === 0 && canZero === false)) {
    return errorMessage + "FormNo(" + formNo + ") -" + keyName + vueInstance.$t('MUST_MORE_THAN_ZERO') + " <br>";
  }
  if (Number(key.toString().split("").reverse().join("").indexOf(".")) > Number(digitsNumber)) {
    return errorMessage + "FormNo(" + formNo + ") -" + keyName + digitsName + " <br>";
  }
  return errorMessage;
}

function buildCriteria(vueInstance) {

  vueInstance.priceList.forEach(price => {
    if (price.key == "RM_COST") {
      vueInstance.metalQuotation.rmCost = price.value
    } else if (price.key == "PROCESSING_COST") {
      vueInstance.metalQuotation.processingCost = price.value
    } else if (price.key == "TREATMENT") {
      vueInstance.metalQuotation.treatmentCost = price.value
    } else if (price.key == "ACCESSORIES") {
      vueInstance.metalQuotation.accessoriesCost = price.value
    } else if (price.key == "OTHERS_PROCESS") {
      vueInstance.metalQuotation.others = price.value
    }
  })

  return {
    'currency': vueInstance.quotation.currency,
    'price': vueInstance.price,
    'supplierQuotationFiles': vueInstance.supplierQuotationFiles,
    'uuid': vueInstance.quotation.uuid,
    'category': 'METAL',
    'metalQuotationDto': {
      'length': vueInstance.metalQuotation.length,
      'width': vueInstance.metalQuotation.width,
      'height': vueInstance.metalQuotation.height,
      'weight': vueInstance.metalQuotation.weight,
      'rmPrice': vueInstance.metalQuotation.rmPrice,
      'rmPriceDate': vueInstance.metalQuotation.rmPriceDate,
      'rawMaterialTypeId': vueInstance.metalQuotation.rawMaterialType.uuid,
      'rmVendorId': vueInstance.metalQuotation.rmVendor.uuid,
      'coilCenterId': vueInstance.metalQuotation.coilCenter.uuid,
      'rmCost': vueInstance.metalQuotation.rmCost,
      'processingCost': vueInstance.metalQuotation.processingCost,
      'treatmentCost': vueInstance.metalQuotation.treatmentCost,
      'accessoriesCost': vueInstance.metalQuotation.accessoriesCost,
      'others': vueInstance.metalQuotation.others,
      'supplierRemark': vueInstance.metalQuotation.supplierRemark,
    }
  }
}
</script>
  
<style scoped></style>
  